import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { DeleteIcon } from '@/icons/delete-icon';
import { subGroupClubGallery } from '@/services/groupsManagement/subGroupClubGallery.types';
import type { ColumnDef } from '@tanstack/react-table';

export function getColumns(): ColumnDef<subGroupClubGallery>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title="S.N." />,
      cell: ({ row }) => <div className="truncate max-w-[6rem] font-medium">{row.getValue('sn')}</div>,
      enableHiding: false,
    },
    {
      accessorKey: 'imageTitle',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Image Title" />,
      cell: ({ row }) => <div className="font-medium">{row.getValue('imageTitle')}</div>,
    },
    {
      accessorKey: 'image',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Image" />,
      cell: ({ row }) => {
        const imageUrl: string = row.getValue('image');
        return <img src={imageUrl} alt="Gallery" className="h-12 w-20 object-cover rounded border" />;
      },
    },
    {
      accessorKey: 'updatedOn',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Update On" />,
      cell: ({ row }) => <div className="font-medium">{row.getValue('updatedOn')}</div>,
    },
    {
      id: 'actions',
      accessorKey: 'actions',
      cell: () => {
        return (
          <div className="flex gap-4">
            <DeleteIcon className="cursor-pointer text-destructive-text" />
          </div>
        );
      },
      size: 40,
    },
  ];
}
